import type { KnowledgeSourceListItem } from '@/entities/knowledgeSources';
import type { SearchResult } from '../types';
import { search } from '../api';
import type { SearchKnowledgeSourceRequest } from './types';

export const searchKnowledgeSources = async (
  request: SearchKnowledgeSourceRequest,
): Promise<SearchResult<KnowledgeSourceListItem>> => {
  return search<KnowledgeSourceListItem>(request);
};
